export enum EDIType {
	As2 = 10,
	OFTP = 20,
}